"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
const react_1 = __importDefault(require("react"));
const fortunes_1 = __importDefault(require("../store/fortunes"));
const settings_1 = require("./settings");
const wheel_1 = require("./wheel");
require("./app.css");
exports.App = () => (react_1.default.createElement("div", { className: "main-app" },
    react_1.default.createElement(wheel_1.Wheel, { onToggleSettings: fortunes_1.default.toggleSettings }),
    react_1.default.createElement(settings_1.Settings, null)));
